import { Instance } from 'mobx-state-tree';
import { ProjectPaginatedDtoModelBase } from './ProjectPaginatedDtoModel.base';

/* The TypeScript type of an instance of ProjectPaginatedDtoModel */
export interface ProjectPaginatedDtoModelType extends Instance<typeof ProjectPaginatedDtoModel.Type> {}

/* A graphql query fragment builders for ProjectPaginatedDtoModel */
export { selectFromProjectPaginatedDto, projectPaginatedDtoModelPrimitives, ProjectPaginatedDtoModelSelector } from './ProjectPaginatedDtoModel.base';

/**
 * ProjectPaginatedDtoModel
 */
export const ProjectPaginatedDtoModel = ProjectPaginatedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
